<template>
  <div v-if="isNotified" class="alert">
    <span
      @click="checkCookie"
      class="closebtn"
      onclick="this.parentElement.style.display='none';"
      >&times;</span
    >
    <!-- <span>Fadlan msaajidka tabarruc.</span> -->
    <span class="text-span" style="font-size: 22px;">من فضلك، تبرع للمسجد</span>
    <span class="text-span">Fadlan sadaqada masaajidka bixi.</span>
    <span class="text-span">Please, donate to the mosque.</span>
    <span class="text-span">Ole hyvä ja lahjoita moskeijalle.</span>
    <span class="text-span" style="font-weight: bold;color:#000;"
      >Tili: FI12 5741 3620 6609 74
    </span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isNotified: false,
    };
  },
  methods: {
    setCookie(cname, cvalue, exdays) {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },

    getCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          //return c.substring(name.length, c.length);
          return true;
        }
      }
      //return "";
      return false;
    },

    checkCookie() {
      var user = this.getCookie("info");
      if (user) {
        this.isNotified = false;
      } else {
        this.setCookie("info", "2555833780632468", 1);
        this.isNotified = true;
      }
    },
  },
  mounted() {
    this.checkCookie();
  },
};
</script>
<style scoped>
/* The alert message box */
.alert {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 120;
  padding: 20px;
  /* background-color: #f44336; */
  /* background-color: #2196f3; */
  background-color: #ff9800;
  color: white;
  margin-bottom: 15px;
  box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
}

.alert:hover {
  box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.35);
}

/* The close button */
.closebtn {
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  font-weight: bold;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: all 0.3s;
}

/* When moving the mouse over the close button */
.closebtn:hover {
  color: black;
}

.text-span {
  display: block;
  font-size: 1.6rem;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
  text-transform: uppercase;
}
</style>
